import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "basisCard", "proCard", "stats", "cta"]

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.animateIn()
        }
      },
      { threshold: 0.2 }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  animateIn() {
    const targets = [
      this.headerTarget,
      this.basisCardTarget,
      this.proCardTarget,
      this.statsTarget,
      this.ctaTarget
    ]

    targets.forEach((target) => {
      if (target) {
        target.classList.remove("opacity-0", "translate-y-8")
        target.classList.add("opacity-100", "translate-y-0")
      }
    })
  }
}
